import React, { useState } from 'react';
import { X, Search, Plus, Palette } from 'lucide-react';
import { PiExport, PiExportFill } from 'react-icons/pi';
import './TaskFilterationActions.css';


const TaskFilterationActions = ({ viewMode, onFilterChange, onExport, onImport, onCustomDownload, onAdd, onDesignMode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [dateFilter, setDateFilter] = useState('');
    const [customDateStart, setCustomDateStart] = useState('');
    const [customDateEnd, setCustomDateEnd] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [outcomeFilter, setOutcomeFilter] = useState('');

    // New Sorting State     
    const [sortBy, setSortBy] = useState('date_desc'); 

    // New Advanced Search State
    const [applyLogic, setApplyLogic] = useState('AND'); 
    const [searchRows, setSearchRows] = useState([
        { id: Date.now(), field: '', operator: 'contains', value: '' }
    ]);

    // Table View Toolbar visibility
    const [showToolbar, setShowToolbar] = useState(false);

    const toggleSettings = () => {
        setIsOpen(!isOpen);
    };

    const toggleToolbar = () => {
        setShowToolbar(!showToolbar);
    };

    const addSearchRow = () => {
        setSearchRows([...searchRows, { id: Date.now(), field: '', operator: 'contains', value: '' }]);
    };

    const removeSearchRow = (id) => {
        if (searchRows.length > 1) {
            setSearchRows(searchRows.filter(row => row.id !== id));
        }
    };

    const updateSearchRow = (id, field, val) => {
        setSearchRows(searchRows.map(row => row.id === id ? { ...row, [field]: val } : row));
    };

    const handleApplySearch = () => {
        if (onFilterChange) {
            onFilterChange({
                dateFilter,
                customDateStart,
                customDateEnd,
                statusFilter,
                outcomeFilter,
                sortBy,
                applyLogic,
                searchRows: searchRows.filter(row => row.field && row.value)
            });
        }
        setIsOpen(false);
    };

    const handleClearFilters = () => {
        setDateFilter('');
        setCustomDateStart('');
        setCustomDateEnd('');
        setStatusFilter('');
        setOutcomeFilter('');
        setSortBy('date_desc');
        setApplyLogic('AND');
        setSearchRows([{ id: Date.now(), field: '', operator: 'contains', value: '' }]);

        if (onFilterChange) {
            onFilterChange({
                dateFilter: '',
                customDateStart: '',
                customDateEnd: '',
                statusFilter: '',
                outcomeFilter: '',
                sortBy: 'date_desc',
                applyLogic: 'AND',
                searchRows: []
            });
        }
        setIsOpen(false);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    return (
        <div className="task-filtration-container">
            {viewMode === 'table' ? (
                <div className="table-view-actions-wrapper">
                    {!showToolbar ? (
                        <div className="bd-theme-settings">
                        </div>
                    ) : (
                        <div className="table-operations-toolbar animate-slide-in">
                            <button className="op-btn" onClick={toggleToolbar} title="Close">
                                <X size={20} />
                            </button>
                            <div className="divider"></div>
                            <button className="op-btn" title="Design Theme" onClick={onDesignMode}>
                                <Palette size={20} />
                            </button>
                            <div className="divider"></div>
                            <button className="op-btn highlight add-task-btn" title="Add Task" onClick={onAdd}>
                                <Plus size={24} />
                            </button>
                            <div className="divider"></div>
                            <button className="op-btn" title="Export" onClick={onExport}>
                                <PiExport size={24} />
                            </button>
                            <div className="divider"></div>
                            <button className="op-btn" title="Download" onClick={onCustomDownload}>
                                <PiExportFill size={24} />
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <div className="bd-theme-settings-group">
                    <button className="op-btn" title="Design Theme" onClick={onDesignMode}>
                        <Palette size={20} />
                    </button>
                    <div className="divider"></div>
                    <button className="op-btn highlight add-task-btn" title="Add Task" onClick={onAdd}>
                        <Plus size={24} />
                    </button>
                </div>
            )}

            {isOpen && (
                <div className="filter-panel-overlay">
                    <div className="filter-panel">
                        <div className="filter-header">
                            <h3>Advance Filters</h3>
                            <button className="close-btn" onClick={toggleSettings}>&times;</button>
                        </div>

                        <div className="filter-body scrollable-filter-body">
                            <div className="filter-group">
                                <label>Order By</label>
                                <select
                                    className="form-control"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="date_desc">Date (Newest First)</option>
                                    <option value="date_asc">Date (Oldest First)</option>
                                    <option value="owner_asc">Owner Name (A-Z)</option>
                                    <option value="owner_desc">Owner Name (Z-A)</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label>Filter By Date</label>
                                <select
                                    className="form-control"
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="Today">Today</option>
                                    <option value="Tomorrow">Tomorrow</option>
                                    <option value="overdue">Overdue</option>
                                    <option value="custom">Custom Date</option>
                                </select>
                            </div>

                            {dateFilter === 'custom' && (
                                <div className="filter-row">
                                    <div className="filter-col">
                                        <label>Start Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={customDateStart}
                                            onChange={(e) => setCustomDateStart(e.target.value)}
                                        />
                                    </div>
                                    <div className="filter-col">
                                        <label>End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={customDateEnd}
                                            onChange={(e) => setCustomDateEnd(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="filter-row">
                                <div className="filter-col">
                                    <label>Status</label>
                                    <select
                                        className="form-control"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">Status</option>
                                        <option value="open">Open</option>
                                        <option value="completed">Completed</option>
                                    </select>
                                </div>
                                <div className="filter-col">
                                    <label>Outcomes</label>
                                    <select
                                        className="form-control"
                                        value={outcomeFilter}
                                        onChange={(e) => setOutcomeFilter(e.target.value)}
                                    >
                                        <option value="">Outcomes</option>
                                        <option value="interested">Interested</option>
                                        <option value="not_interested">Not Interested</option>
                                        <option value="noresponse">No Response</option>
                                    </select>
                                </div>
                            </div>

                            {viewMode === 'table' && (
                                <>
                                    <hr className="filter-divider" />
                                    <div className="advanced-search-header">
                                        <h4>Advanced Search</h4>
                                        <div className="apply-toggle">
                                            <label>
                                                <input type="radio" value="AND" checked={applyLogic === 'AND'} onChange={() => setApplyLogic('AND')} />
                                                All
                                            </label>
                                            <label>
                                                <input type="radio" value="OR" checked={applyLogic === 'OR'} onChange={() => setApplyLogic('OR')} />
                                                Any
                                            </label>
                                        </div>
                                    </div>

                                    <div className="search-rows-container">
                                        {searchRows.map((row, index) => (
                                            <div key={row.id} className="search-row">
                                                <div className="row-field-group">
                                                    <select
                                                        className="form-control field-select"
                                                        value={row.field}
                                                        onChange={(e) => updateSearchRow(row.id, 'field', e.target.value)}
                                                    >
                                                        <option value="">Field</option>
                                                        <option value="name">Lead Name</option>
                                                        <option value="taskTitle">Task Title</option>
                                                        <option value="enquiryId">Enquiry ID</option>
                                                        <option value="description">Description</option>
                                                    </select>
                                                    <select
                                                        className="form-control op-select"
                                                        value={row.operator}
                                                        onChange={(e) => updateSearchRow(row.id, 'operator', e.target.value)}
                                                    >
                                                        <option value="contains">Contains</option>
                                                        <option value="equals">Equals</option>
                                                        <option value="startsWith">Starts</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control value-input"
                                                    placeholder="Value"
                                                    value={row.value}
                                                    onChange={(e) => updateSearchRow(row.id, 'value', e.target.value)}
                                                />
                                                <div className="row-actions">
                                                    {index === searchRows.length - 1 ? (
                                                        <button className="add-row-btn" onClick={addSearchRow}>+</button>
                                                    ) : (
                                                        <button className="remove-row-btn" onClick={() => removeSearchRow(row.id)}>−</button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="filter-footer">
                            <button type="button" className="btn-clear" onClick={handleClearFilters}>Clear All</button>
                            <div className="footer-right-btns">
                                <button type="button" className="btn-cancel" onClick={handleCancel}>Cancel</button>
                                <button type="button" className="btn-search" onClick={handleApplySearch}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TaskFilterationActions;
